import React from 'react';

/* The B/N mark: a hub and the six builders around it. `spinning` turns the
   outer ring (the loader); the hub stays still. `hub` shows the centre dot
   when nothing (like the member count) sits on top of it. */
export default function BNMark({ size = 52, spinning = false, hub = false, className = '' }) {
  return (
    <svg className={`bn-mark${spinning ? ' spinning' : ''} ${className}`} width={size} height={size} viewBox="0 0 62 62" aria-hidden="true">
      <defs>
        <radialGradient id="bn-core-g" cx=".35" cy=".3" r=".8">
          <stop offset="0" stopColor="#3D8BFF" />
          <stop offset="1" stopColor="#1340B8" />
        </radialGradient>
      </defs>
      <g className="bn-ring">
        <g stroke="#7DBBFF" strokeWidth="1.6">
          <line x1="31" y1="5" x2="31" y2="16" /><line x1="31" y1="46" x2="31" y2="57" />
          <line x1="8.5" y1="18" x2="18" y2="23.5" /><line x1="53.5" y1="18" x2="44" y2="23.5" />
          <line x1="8.5" y1="44" x2="18" y2="38.5" /><line x1="53.5" y1="44" x2="44" y2="38.5" />
        </g>
        <g fill="#9CCBFF">
          <circle cx="31" cy="5" r="3.2" /><circle cx="31" cy="57" r="3.2" /><circle cx="8.5" cy="18" r="3.2" />
          <circle cx="53.5" cy="18" r="3.2" /><circle cx="8.5" cy="44" r="3.2" /><circle cx="53.5" cy="44" r="3.2" />
        </g>
      </g>
      <circle cx="31" cy="31" r="15" fill="url(#bn-core-g)" stroke="#9CCBFF" strokeWidth="1.6" />
      {hub && <circle cx="31" cy="31" r="4.5" fill="#EAF4FF" />}
    </svg>
  );
}
